<template>
  <div class="third app-setting-main">
    <div class="third-formOne adhibition">
      <div class="formOne-btn">
        <div class="btn-left">
          <!-- <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>-->
          <span class="left-back-content">应用卡片配置</span>
          <!-- <span v-if="IDlist !== ''" class="left-back-content">编辑班级信息</span> -->
        </div>
        <div class="btn-right">
          <!-- <el-button class="btn-two" type="default" @click="Reset">重置</el-button>
          <el-button
            class="btn-two"
            type="primary"
            @click="updateOrganizationFN"
            v-el-disabel-repeat-click
          >保存</el-button> -->
        </div>
      </div>

      <div class="formOne-forms" style="width: 60%; float: left">
        <div class="forms-one" style="margin-top: 45px"></div>
        <div class="forms-one">
          <div class="one-title">
            <div class="title-left">
              <span class="left-icon">
                <i class="el-icon-s-operation"></i>
              </span>
              <span class="left-content">卡片配置</span>
            </div>
          </div>
          <div class="one-list">
            <el-table
              ref="faqTableData"
              class="third-tableThree"
              :data="tableData"
              empty-text="暂无数据"
              border
              stripe
              v-loading="loading"
            >
              <el-table-column prop="itemName" label="卡片"></el-table-column>
              <el-table-column
                prop="showName"
                label="展示名称"
              ></el-table-column>
              <el-table-column prop="orderNum" label="顺序"></el-table-column>
              <el-table-column prop="openStatus" label="状态">
                <template slot-scope="{ row }">
                  <span
                    :style="{
                      color: row.openStatus === '1' ? '#33CC99' : '#FF4D4F',
                    }"
                    >{{ row.openStatus === "1" ? "启用" : "停用" }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="updateTime"
                label="更新时间"
              ></el-table-column>
              <el-table-column min-width="80px" label="操作">
                <template slot-scope="{ row }">
                  <el-button
                    type="text"
                    size="small"
                    @click="goEdit(row)"
                    :disabled="row.editStatus === 'ALL'"
                    >编辑</el-button
                  >
                  <span class="tableThree-height-shu">
                    <span class="shu-item"></span>
                  </span>
                  <el-button
                    type="text"
                    size="small"
                    :disabled="
                      row.editStatus === 'ALL' || row.editStatus === 'STATUS'
                    "
                    style="marginLeft:0 !important;"
                    @click="confirmUpdateStatus(row)"
                  >
                    {{ row.openStatus !== "1" ? "启用" : "停用" }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="bottom-row">
            <el-button
              type="primary"
              :disabled="isUpdate === 1"
              @click="updateNewSetting"
              >发布最新配置</el-button
            >
            <span :style="{ color: isUpdate === 1 ? '#33CC99' : '#FF4D4F' }">{{
              isUpdate === 0 ? "未发布最新配置" : "已发布最新配置"
            }}</span>
          </div>
        </div>
      </div>
      <div class="phon-right">
        <img class="phon-right-img" src="@/assets/fwpz.png" alt="" />
      </div>
    </div>
    <notice-modal
      :noticeModalVisible="noticeModal"
      @noticeModalClose="closeNotice"
      @noticeModalAgree="agreeNotice"
      :noticeTitle="noticeTitle"
      :noticeSpec="noticeSpec"
      :noticeType="noticeType"
      :btnAgree="agreeContent"
      :noticeContent="noitceContent"
    >
    </notice-modal>
  </div>
</template>

<script>
import {
  organizationDetails,
  updateOrganization
} from "@/store/appconfig/organization"; //我的
import { getItemListPort, updateStatusPort, issueNewConfigPort } from '@/api/appSetting/appServiceSetting'

export default {
  name: "formSeven",
  data () {
    return {
      isUpdate: 0,
      //   &********弹框******************************
      agreeNotice: {},
      noticeType: 1, // 提示类型
      agreeContent: '确定', // 提示弹窗确认按钮内容
      noticeTitle: '提示', // 提示
      noitceContent: '启用后组件将在服务页面展示，确定启用吗？', // 提示信息
      noticeModal: false, // 提示弹窗
      noticeSpec: '', // 标红提示
      //   &**************************************
      rules: {
        schoolId: [
          { required: true, message: "请输入学校代码", trigger: "blur" }
        ],
        schoolName: [
          { required: true, message: "请输入学校名称", trigger: "blur" }
        ]
      },
      tableData: [],
      loading: false,
      //===============================
      student: [], //学生栏
      teacher: [] //教工栏
    };
  },
  created () {
    // this.organizationDetailsFN();
    this.getItemList()
  },
  methods: {
    goEdit (rowData) {
        console.log(rowData)
      let componentName = ''
      switch (rowData.id) {
        case '2': {
            // TODO  记得改回去 importPub
          componentName = 'importPub'
          break
        }
        case '3': {
          componentName = 'myService'
          break
        }
        case '4': {
          componentName = 'thirdService'
          break
        }
        case '5': {
          componentName = 'information'
          break
        }
        case '6': {
          componentName = 'serviceScenariosAndAervices'
          break
        }
        case '7': {
          componentName = 'special'
          break
        }
        case '8': {
          componentName = 'timetable'
          break
        }
        case '9': {
          componentName = 'backlog'
          break
        }
        default: {
          return
        }
      }
      this.$emit('changeComponent', componentName, rowData.id)
    },
    confirmUpdateStatus (rowData) {
      const params = {
        id: rowData.id,
        openStatus: ''
      }
      if (rowData.openStatus !== '1') {
        this.noitceContent = '启用后组件将在服务页面展示，确定启用吗？'
        params.openStatus = 1
      } else {
        this.noitceContent = '停用后组件不再展示到服务页面，确定停用吗？'
        params.openStatus = 0
      }
      this.agreeNotice = () => {
        this.noticeModal = false
        return this.updateStatus(params)
      }
      this.noticeModal = true
    },
    updateNewSetting () {
      this.noitceContent = '确定发布最新配置吗？'
      this.agreeNotice = () => {
        this.noticeModal = false
        return this.issueNewConfig()
      }
      this.noticeModal = true
    },
    async getItemList () {
      this.loading = true
      const {
        data: {
          result, msg, status
        }
      } = await getItemListPort()
      if (status === 1000) {
        this.tableData = result.dataList
        this.isUpdate = result.isUpdate
        console.log('result', result)
        this.loading = false
        return
      }
      this.loading = false
      return this.$message.error(msg)
    },
    async issueNewConfig () {
      const {
        data: {
          result, msg, status
        }
      } = await issueNewConfigPort()
      if (status === 1000) {
        this.$message.success('操作成功')
        this.getItemList()
        return
      }
      return this.$message.error(msg)
    },
    async updateStatus (params) {
      const {
        data: {
          result, msg, status
        }
      } = await updateStatusPort(params)
      if (status === 1000) {
        this.$message.success('操作成功')
        this.getItemList()
        return
      }
      return this.$message.error(msg)
    },
    // // 确认弹窗
    // agreeNotice () {
    //   let action = ''
    //   let data
    //   // 确认状态
    //   if (this.noticeDispatch === 'status') {
    //     action = 'serviceUpdateStatus'
    //     data = this.statusData
    //   }
    //   // 确认删除
    //   if (this.noticeDispatch === 'del') {
    //     action = 'serviceRemoveData'
    //     data = { ids: this.delId }
    //   }
    //   this.$store.dispatch(
    //     action,
    //     data
    //   ).then((res) => {
    //     if (res.data.status === 1000) {
    //       this.getTableData();
    //       this.$message({
    //         message: '操作成功！',
    //         type: 'success'
    //       });
    //     } else {
    //       this.$message.error(res.data.msg);
    //     }
    //     this.noticeModal = false
    //   })
    // },
    // 关闭弹窗
    closeNotice () {
      this.noticeModal = false
    },
    //重置
    Reset () {
      this.getItemList();
    },
    //获取显示
    organizationDetailsFN () {
      try {
        organizationDetails().then(res => {
          const data = res.data;
          if (data.status === 1000) {
            this.student = data.result.student;
            this.teacher = data.result.teacher;
            // console.log(this.student);
          } else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //保存
    updateOrganizationFN () {
      console.log("进啦了");
      try {
        let next = true;
        let setData = [];
        // setData = this.teacher.concat(this.student);
        setData.push.apply(setData, this.student);
        setData.push.apply(setData, this.teacher);
        // console.log(setData);
        setData.forEach(item => {
          if (item.value == "") {
            next = false;
          }
        });
        if (next) {
          const params = setData;
          updateOrganization(params).then(res => {
            const data = res.data;
            if (data.status === 1000) {
              this.$message.success("操作成功");
            } else {
              this.$message({
                type: "error",
                message: data.msg
              });
            }
          });
        } else {
          this.$message.error("请填写完整信息");
        }
      } catch (err) {
        console.log(err);
      }
    }
    //==========================================================
    //上传图片
  }
};
</script>

<style lang="scss">
.app-setting-main {
  .bottom-row {
    margin-top: 15px;
    font-size: 12px;
    .el-button {
      margin-left: 0 !important;
      margin-right: 5px;
    }
  }
  .tableThree-height-shu {
				display: inline-block;
				padding: 0 4px;
				position: relative;
				.shu-item {
					position: absolute;
					width: 1px;
					height: 12px;
					background-color: #d4d4d7;
					display: inline-block;
					top: -10px;
				}
			}
}
.organization-sepec-notice {
  line-height: 32px;
  font-size: 12px;
  color: #ff4d4f;
  .el-icon-warning {
    margin-right: 8px;
  }
}
.phon-right {
  position: relative;
  // border:1px solid red;
  width: 40%;
  display: inline-block;
  height: calc(100vh - 102px);
  border-left: 1px solid #dcdee2;
  img {
    // border: 1px solid red;
    width: 389px;
    height: 669px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
  }
}
</style>
